import React, { useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useEditMode } from '../../context/EditModeContext';
import { useContent } from '../../context/ContentContext';
import { promptImageUrl, readImageFile } from '../../utils/imageUpload';
import './editable.css';

export default function EditableImage({
  contentKey,
  src,
  alt = '',
  className = '',
  ...rest
}) {
  const { isEditing } = useAuth();
  const { controlsVisible, activeFieldKey } = useEditMode();
  const showToolbar = controlsVisible || activeFieldKey === contentKey;
  const { getContent, setContentValue, clearContentValue } = useContent();
  const fileInputRef = useRef(null);

  const displaySrc = getContent(contentKey, src);

  const applyImage = async (file) => {
    try {
      const dataUrl = await readImageFile(file);
      setContentValue(contentKey, dataUrl);
    } catch (error) {
      window.alert(error.message);
    }
  };

  const handleReplaceClick = () => {
    fileInputRef.current?.click();
  };

  const handleUrlClick = () => {
    const url = promptImageUrl();
    if (url) setContentValue(contentKey, url);
  };

  const handleResetClick = () => {
    if (window.confirm('Reset this image to the original?')) {
      clearContentValue(contentKey);
    }
  };

  if (!isEditing) {
    return <img src={displaySrc} alt={alt} className={className} {...rest} />;
  }

  return (
    <span
      className={`editable-image-wrap ${className ? `${className}-wrap` : ''}`}
      data-content-key={contentKey}
    >
      <img src={displaySrc} alt={alt} className={className} {...rest} />
      {showToolbar && (
      <span className="editable-image-toolbar" role="toolbar" aria-label="Image editing tools">
        <button type="button" className="editable-image-btn" onClick={handleReplaceClick}>
          Replace
        </button>
        <button type="button" className="editable-image-btn" onClick={handleUrlClick}>
          URL
        </button>
        <button type="button" className="editable-image-btn editable-image-btn--danger" onClick={handleResetClick}>
          Reset
        </button>
      </span>
      )}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        className="editable-image-input"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) applyImage(file);
          e.target.value = '';
        }}
      />
    </span>
  );
}
